




























import Vue from 'vue';

export default Vue.extend({
  props: {
    fonts: {
      type: Array,
      default() {
        return [];
      },
    },
    selectedFont: {
      type: String,
    },
  },
});
